
import { Component, Vue, Prop } from 'vue-property-decorator';
import Dialog from '@/components/Dialog.vue';
import ruleMixin from '@/minix/ruleMixin';
import { Route } from 'vue-router';
import api from '@/api';
import Swal from 'sweetalert2';
import zipcode from '@/zipcode.json';

const zc: { [key: string]: { [key: string]: number } } = zipcode;

const { store } = api;

@Component({
  components: {
    Dialog,
  },
  mixins: [ruleMixin],
})
export default class StoreForm extends Vue {
  @Prop() private merchantId!: number;

  @Prop() private storeId!: string;

  private loading = false;

  private valid = true;

  private form = {
    storeName: '',
    city: '',
    area: '',
    address: '',
  };

  private get cities() {
    return Object.keys(zc);
  }

  private get districts() {
    return Object.keys(zc[this.form.city] || {});
  }

  private async save() {
    if ((this.$refs.form as any).validate()) {
      this.loading = true;
      const { status } = this.isEdit
        ? await store.edit(this.merchantId, this.storeId, this.form)
        : await store.add(this.merchantId, this.form);
      this.loading = false;
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: `${this.title}成功` });
        await this.$router.back();
      }
    }
  }

  private async close() {
    await this.$router.back();
  }

  private get isEdit() {
    return !!this.storeId;
  }

  private get title() {
    return this.isEdit ? '編輯' : '新增';
  }

  private setForm(data: {
    storeName: string;
    city: string;
    area: string;
    address: string;
  }) {
    this.form = data;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: StoreForm) => void) | boolean) => void,
  ) {
    const { merchantId, storeId } = to.params;
    if (storeId) {
      const { status, data } = await store.get(merchantId, storeId);
      if (status === 1) {
        next((vm) => {
          vm.setForm(data);
        });
      } else {
        next(false);
      }
    } else {
      next(true);
    }
  }
}
